import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useMainContext } from './hooks/useMainContext';

const ProtectedRoute = observer(({ children }) => {
    const { viewManager } = useMainContext();
    const location = useLocation();

    if (!viewManager.isLoggedIn) {
        return <Navigate to={`/auth/login${location.search}`} replace />;
    }

    return children;
});

export default ProtectedRoute;
